import React from "react"
import { useTranslation } from 'react-i18next'
import { Text } from "../Typography";

const SectionTitle = ({ level = 'title-sm', icon, className, label, subtitle }) => {
    const { t } =  useTranslation();

    className = (typeof className != typeof undefined) ? className+" form-element" : "form-element";

    const children = subtitle ? <div style={{display:'flex',flexDirection:'column'}}><span style={{width:'100%'}}>{t(label)}</span><span style={{fontSize:'10px', fontWeight:'300', width:'100%'}}>{t(subtitle)}</span></div> : t(label);

    return <Text level={level} icon={icon} className={className} children={children} />
}

export default SectionTitle